export const getQueryString = function(name, type){  
  const url = type === 'hash' ? window.location.hash : window.location.href; //获取url中"?"符后的字串
  let arr = []
  let params = {}
  if (url.indexOf("?") !== -1) {
    arr = url.split('?')[1].split('&')
    arr.forEach(item => {
      let data = item.split('=')
      if (data.length === 2) {
        params[data[0]] = data[1]
      }
    })
  }
  return params[name] || ''
}
export const formatTime = date => {
  if (typeof date === 'string') {
    date = date
      .substr(0, 16)
      .replace(/-/g, '/')
      .replace('T', ' ')
    // date = _date.replace(/-/g, '/')
  }
  const newDate = new Date(date)
  const year = newDate.getFullYear()
  const month = newDate.getMonth() + 1
  const day = newDate.getDate()
  const hour = newDate.getHours()
  const minute = newDate.getMinutes()
  const second = newDate.getSeconds()
  const weekDayList =  new Array("周日", "周一", "周二", "周三", "周四", "周五", "周六");
  const weekToDay =  newDate.getDay()
  return {
    year: year,
    month:String(month).length === 1 ? '0' + month : month,
    day: String(day).length === 1 ? '0' + day : day,
    hour: String(hour).length === 1 ? '0' + hour : hour,
    minute:  String(minute).length === 1 ? '0' + minute : minute,
    second:  String(second).length === 1 ? '0' + second : second,
    week: weekDayList[weekToDay]
  }
}
export function isIOS () {
  let isIphone = navigator.userAgent.includes('iPhone')
  let isIpad = navigator.userAgent.includes('iPad')
  return isIphone || isIpad
}
export function isPc () {
  const plat = navigator.platform
  const win = plat.indexOf("Win") == 0
  const mac = plat.indexOf("Mac") == 0
  if (win || mac) {
    return true
  } else {
    return false
  }
}
export const formatExifTime = date => {
  if (typeof date === 'string') {
    date = date
      .substr(0, 10)
      .replace(/-/g, '/')
      .replace('T', ' ')
      .replace(/:/g, '/')
    // date = _date.replace(/-/g, '/')
  }
  const newDate = new Date(date)
  const year = newDate.getFullYear()
  let month = newDate.getMonth() + 1
  String(month).length === 1 && (month = '0' + month)
  let day = newDate.getDate()
  String(day).length === 1 && (day = '0' + day)
  return `${year}-${month}-${day}`
}
export const checkPhone = () => {
  const userAgent = window.navigator.userAgent
  if (!userAgent) return '--'
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return 'Ios'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    //alert(navigator.userAgent); 
    return 'Android'
  } else {
    return '--'
  }
}

/**
 * 检验用户手机号是否是国内规则
 */
export const checkValidUserPhone = (value) => {
  return /^1\d{10}$/g.test(value)
}